<ng-container [formGroup]="form">
  <mat-form-field class="w-100">
    <mat-label>Adresse du siège</mat-label>
    <input matInput formControlName="address" />
  </mat-form-field>
  <div class="flex gap">
    <mat-form-field class="w-100">
      <mat-label>Code postal</mat-label>
      <input matInput formControlName="postalCode" />
    </mat-form-field>
    <mat-form-field class="w-100">
      <mat-label>Ville</mat-label>
      <input matInput formControlName="city" appToUppercase />
    </mat-form-field>
  </div>

  <div class="flex gap">
    <mat-form-field class="w-100">
      <mat-label>Forme juridique</mat-label>
      <input matInput formControlName="legalForm" />
    </mat-form-field>
    <mat-form-field class="w-100">
      <mat-label>Numéro SIREN</mat-label>
      <input matInput formControlName="siren" />
    </mat-form-field>
  </div>

  <div class="flex gap">
    <mat-form-field class="w-100">
      <mat-label>Numéro SIRET du siège</mat-label>
      <input matInput formControlName="siret" />
    </mat-form-field>
    <mat-form-field class="w-100">
      <mat-label>Numéro RCS</mat-label>
      <input matInput formControlName="rcs" />
    </mat-form-field>
  </div>

  <div class="flex gap">
    <mat-form-field class="w-100">
      <mat-label>Capital</mat-label>
      <input matInput formControlName="capital" type="number" />
    </mat-form-field>
  </div>

  <h4>Représentant</h4>
  <div class="flex gap">
    <mat-radio-group formControlName="legalRepresentativeTitle" class="w-100 employee-title">
      <mat-label>Titre</mat-label>
      @for (title of PersonTitles; track $index) {
        <mat-radio-button [value]="title">{{ title }}</mat-radio-button>
      }
    </mat-radio-group>
  </div>
  <div class="flex gap">
    <mat-form-field class="w-100">
      <mat-label>Nom du représentant légal</mat-label>
      <input matInput formControlName="legalRepresentative" />
    </mat-form-field>
    <mat-form-field class="w-100">
      <mat-label>Qualité du représentant légal</mat-label>
      <input matInput formControlName="legalRepresentativePosition" />
    </mat-form-field>
  </div>
</ng-container>
